export const marketCreateConfig = (createSelectOptions) => {
  return [
    {
      step_title: 'Name',
      form_title: 'Market Configuration',
      section: [
        {
          name: 'name',
          placeholder: 'Enter Market Name',
          input: 'input',
          rules: [
            {
              required: true,
              message: 'Market name is required',
            },
          ],
        },
        {
          name: 'network_radius',
          input: 'inputNumber',
          max: 1000,
          min: 0,
          precision: 0,
          placeholder: 'Network Radius (miles)',
          rules: [
            {
              required: true,
              message: 'Value required',
            },
          ],
        },
        {
          name: 'unloaded_rate',
          input: 'inputNumber',
          min: 0,
          max: 1000,
          precision: 2,
          placeholder: 'Enter unloaded rate',
          rules: [
            {
              required: true,
              message: 'Value required',
            },
          ],
        },
        {
          name: 'trailer_config',
          input: 'select',
          options: createSelectOptions.trailer_configs,
          type: 'single',
          placeholder: 'Enter trailer config',
          rules: [
            {
              required: true,
              message: 'Value required',
            },
          ],
        },
        {
          name: 'default_transporter',
          input: 'select',
          options: createSelectOptions.counterparty_names,
          type: 'single',
          placeholder: 'Enter default transporter',
          rules: [
            {
              required: false,
            },
          ],
        },
      ],
    },
  ]
}
